import api from './api';

// API service for wallet group operations
export const walletGroupApi = {
  // Create a new wallet group
  async createWalletGroup(groupData, tokenId = null) {
    console.log('walletGroupApi.createWalletGroup: Creating new group, tokenId:', tokenId);
    try {
      const dataWithToken = tokenId ? { ...groupData, token_id: tokenId } : groupData;
      const response = await api.post('/wallet-groups', dataWithToken);
      console.log('walletGroupApi.createWalletGroup: Response:', response.data);
      return response.data;
    } catch (error) {
      console.error('walletGroupApi.createWalletGroup ERROR:', error);
      throw new Error(error.response?.data?.error || 'Failed to create wallet group');
    }
  },
  
  // Get all user wallet groups
  async getWalletGroups(tokenId = null) {
    console.log('walletGroupApi.getWalletGroups: Fetching groups, tokenId:', tokenId);
    try {
      let url = '/wallet-groups';
      if (tokenId) {
        url += `?tokenId=${encodeURIComponent(tokenId)}`;
      }
      const response = await api.get(url);
      console.log(`walletGroupApi.getWalletGroups: Received ${response.data.length} groups`);
      
      return response.data;
    } catch (error) {
      console.error('walletGroupApi.getWalletGroups ERROR:', error);
      
      // If server is down, return empty array
      if (error.isServerDown) {
        console.log('Server appears to be down, returning empty groups list');
        return [];
      }
      
      throw error;
    }
  },
  
  // Get a specific wallet group by ID
  async getWalletGroup(groupId) {
    console.log('walletGroupApi.getWalletGroup: Fetching group:', groupId);
    try {
      const response = await api.get(`/wallet-groups/${groupId}`);
      console.log('walletGroupApi.getWalletGroup: Response:', response.data);
      return response.data;
    } catch (error) {
      console.error('walletGroupApi.getWalletGroup ERROR:', error);
      throw new Error(error.response?.data?.error || 'Failed to fetch wallet group');
    }
  },
  
  // Update a wallet group
  async updateWalletGroup(groupId, updateData) {
    console.log('walletGroupApi.updateWalletGroup: Updating group:', groupId);
    try {
      const response = await api.put(`/wallet-groups/${groupId}`, updateData);
      console.log('walletGroupApi.updateWalletGroup: Response:', response.data);
      return response.data;
    } catch (error) {
      console.error('walletGroupApi.updateWalletGroup ERROR:', error);
      throw new Error(error.response?.data?.error || 'Failed to update wallet group');
    }
  },
  
  // Delete a wallet group
  async deleteWalletGroup(groupId) {
    console.log('walletGroupApi.deleteWalletGroup: Deleting group:', groupId);
    try {
      const response = await api.delete(`/wallet-groups/${groupId}`);
      console.log('walletGroupApi.deleteWalletGroup: Response:', response.data);
      return response.data;
    } catch (error) {
      console.error('walletGroupApi.deleteWalletGroup ERROR:', error);
      throw new Error(error.response?.data?.error || 'Failed to delete wallet group');
    }
  },
  
  // Add wallets to a group
  async addWalletsToGroup(groupId, walletIds) {
    console.log(`walletGroupApi.addWalletsToGroup: Adding ${walletIds.length} wallets to group ${groupId}`);
    try {
      const response = await api.post(`/wallet-groups/${groupId}/wallets`, { walletIds });
      console.log('walletGroupApi.addWalletsToGroup: Response:', response.data);
      return response.data;
    } catch (error) {
      console.error('walletGroupApi.addWalletsToGroup ERROR:', error);
      throw new Error(error.response?.data?.error || 'Failed to add wallets to group');
    }
  },
  
  // Remove wallets from a group
  async removeWalletsFromGroup(groupId, walletIds) {
    console.log(`walletGroupApi.removeWalletsFromGroup: Removing ${walletIds.length} wallets from group ${groupId}`);
    try {
      const response = await api.delete(`/wallet-groups/${groupId}/wallets`, { 
        data: { walletIds } 
      });
      console.log('walletGroupApi.removeWalletsFromGroup: Response:', response.data);
      return response.data;
    } catch (error) {
      console.error('walletGroupApi.removeWalletsFromGroup ERROR:', error);
      throw new Error(error.response?.data?.error || 'Failed to remove wallets from group');
    }
  }
};

export default walletGroupApi;